export const TypographyColorMap: Record<string, string> = {
  success: 'success.main',
  warning: 'warning.main',
  info: 'info.main',
  error: 'error.main',
};
